import axios from 'ts-axios-new';

export function load_shared_data(vm) {
    axios.get('/cms/v1/user/options').then(res => {
        vm.user_options = res.data.data.userList || [];
    }).catch(() => {});
}
